import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessDataUsageBlockData from '../../../Models/Content/BusinessDataUsageBlockData';
import BusinessDataUsageMain from './BusinessDataUsageMain';

export default class BusinessDataUsageBlock extends EpiComponent<BusinessDataUsageBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessDataUsageMain iContent={this.props.data} context={this.getContext()} />;
  }
}
